import fs from 'node:fs'
import { tombstonePath } from './tombstone-path.js'

export function hasTombstone(cwd: string, scope: string): boolean {
  return fs.existsSync(tombstonePath(cwd, scope))
}
